import { HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import {
  LoginGuardGuard,
  regfactcopachisaGuard,
 // LoginRGuardGuard,
  AltaFacturasGuard,
  AltaFacturasddGuard,
  AltaFacturasddNcGuard,
  AuthRedirectGuard,
  RolesGuard,
  UserOptionsGuard,
  VerUsuariosGuard,
  PrivilegiosUsuariosGuard,
  ParametrosGuard,
  OptionsGuard,
  UsuariosCadenasGuard,
  ListasGuard,
  RolesOptionsGuard,
  AltaContribuyentesGuard,
  StpAccountsGuard,
  MantenimientoContribuyentesGuard,
  MantContGuard,
  AltaSolicitudesGuard,
  EstatusSolicitudesGuard,
  ReporteFacturasGuard,
  ReporteDiarioGuard,
  ReporteBancosGuard,
  ReportePagosCompanyGuard,
  ReporteFacturasDetallesGuard,
  ReporteSolicitudesGuard,
  ReporteSolicitudesDetallesGuard,
  ReportecfdisGuard,
  PaymentCfdiGuard,
  ReporteDirectorGuard,
  ReporteSolicitudesFondeoGuard,
  ProyectosProveedoresGuard,
  PagosProveedorGuard,
  PagosCadenaGuard,
  TarifasGuard,
  AltacypGuard,
  UsuariosProveedoresGuard,
  ContribuyentesFundersGuard,
  FunderTagsGuard,
  ContribuyenteFundersGuard,
  SolicituddeFondeoGuard,
  PagosafinancieraGuard,
  PagosafondeadorGuard,
  CuentasContablesGuard,
  GeneraPolizaGuard,
  ConsultaPolizaGuard,
  CobranzaDirectaGuard,
  SoporteGuard,
  FunderUsersGuard,
  DashboardMesaControlGuard,
  DashboardMesaControlService,

  SettingsService,
  SidebarService,
  SharedService,
  UsuarioService,
  StpService,
  PrivilegiosUsuariosService,
  RolesService,
  ParametrosGeneralesService,
  OptionsService,
  UserOptionsService,
  ListasService,
  RolesOptionsService,
  ContribuyentesService,
  AltaSolicitudesService,
  ReportesService,
  PagosService,
  DashboardService,
  TarifasService,
  FacturasService,
  MantenimientoContribuyentesService,
  FundersService,
  MiFielService,
  GuardService,
  ReportesPDFService,
  ContabilidadService,
  MantContEmit,
  NotionService,
  FunderDashboardService,
  FunderUsersService,
  PaymentPollingService,
  FacturacionMasivaGuard,
  FacturacionMasivaService,
  PaymentDetailsService,
  PagosReservaGuard,
  PagosUnificadoGuard
 } from './service.index';

@NgModule({
  imports: [
    CommonModule,
    HttpClientModule
  ],
  providers: [
    LoginGuardGuard,
    regfactcopachisaGuard,
   // LoginRGuardGuard,
    AltaFacturasGuard,
    AltaFacturasddGuard,
    AltaFacturasddNcGuard,
    AuthRedirectGuard,
    RolesGuard,
    UserOptionsGuard,
    VerUsuariosGuard,
    PrivilegiosUsuariosGuard,
    ParametrosGuard,
    OptionsGuard,
    UsuariosCadenasGuard,
    ListasGuard,
    RolesOptionsGuard,
    AltaContribuyentesGuard,
    StpAccountsGuard,
    MantenimientoContribuyentesGuard,
    MantContGuard,
    AltaSolicitudesGuard,
    EstatusSolicitudesGuard,
    ReporteFacturasGuard,
    ReporteDiarioGuard,
    ReporteBancosGuard,
    ReportePagosCompanyGuard,
    ReporteFacturasDetallesGuard,
    ReporteSolicitudesGuard,
    ReporteSolicitudesDetallesGuard,
    ReportecfdisGuard,
    PaymentCfdiGuard,
    ReporteDirectorGuard,
    ReporteSolicitudesFondeoGuard,
    ProyectosProveedoresGuard,
    PagosProveedorGuard,
    PagosCadenaGuard,
    TarifasGuard,
    AltacypGuard,
    UsuariosProveedoresGuard,
    ContribuyentesFundersGuard,
    FunderTagsGuard,
    ContribuyenteFundersGuard,
    SolicituddeFondeoGuard,
    PagosafinancieraGuard,
    PagosafondeadorGuard,
    CuentasContablesGuard,
    GeneraPolizaGuard,
    ConsultaPolizaGuard,
    CobranzaDirectaGuard,
    SoporteGuard,
    FunderUsersGuard,

    SettingsService,
    SidebarService,
    SharedService,
    UsuarioService,
    StpService,
    PrivilegiosUsuariosService,
    RolesService,
    ParametrosGeneralesService,
    OptionsService,
    UserOptionsService,
    ListasService,
    RolesOptionsService,
    ContribuyentesService,
    AltaSolicitudesService,
    ReportesService,
    PagosService,
    DashboardService,
    TarifasService,
    FacturasService,
    MantenimientoContribuyentesService,
    FundersService,
    MiFielService,
    GuardService,
    ReportesPDFService,
    ContabilidadService,
    MantContEmit,
    NotionService,
    // FUNDER DASHBOARD - START
    FunderDashboardService,
    FunderUsersService,
    // FUNDER DASHBOARD - END
    // MESA DE CONTROL - START
    DashboardMesaControlGuard,
    DashboardMesaControlService,
    // MESA DE CONTROL - END
    // Servicio de polling para monitoreo de progreso de pagos
    PaymentPollingService,
    // FACTURACION MASIVA - START
    FacturacionMasivaGuard,
    FacturacionMasivaService,
    // FACTURACION MASIVA - END
    // AJUSTES DETALLES (PAYMENT DETAILS) - START - 01/10/2026
    PaymentDetailsService,
    // AJUSTES DETALLES (PAYMENT DETAILS) - END
    // PAGO RESERVA - START - 01/10/2026
    PagosReservaGuard,
    // PAGO RESERVA - END
    // PAGO UNIFICADO - START - 01/10/2026
    PagosUnificadoGuard,
    // PAGO UNIFICADO - END
  ],
  declarations: []
})
export class ServiceModule { }
